document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.product-form__submit');
  if (!btn) return;

  btn.addEventListener('click', async function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    try {
      // reads id, quantity, properties[__kaching_bundles], etc. — per product
      const formData = new FormData(form);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,                 
        headers: { 'Accept': 'application/json' }
      });

      const data = await res.json();
      if (!res.ok) {
        console.error('Cart error:', data.description || data.message);
        return;
      }

      // open the Kaching cart after the item is added
      window.kachingCartApi?.openCart({ refetchCart: true });

    } catch (err) {
      console.error(err);
    }
  }, true);
});